import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initMetaPixel } from "@/lib/metaPixel";

// Meta Pixel: injeta o script e faz o init só se REACT_APP_META_PIXEL_ID
// estiver configurado. Sem ID, initMetaPixel() é um no-op — nada carrega.
initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
